
import { FolderOpenIcon } from '../Icons/FolderOpenIcon'
import { colors } from '../../styles/colors'
import { FolderIcon } from '../Icons/FolderIcon'
import { FileIcon } from '../Icons/FileIcon'
import {
    ArrowIconNew,
    StyledDot,
    StyledIconWrapper,
    StyledItemWrapper,
    StyledListItemText,
    StyledArrowWrapper,
    StyledTreeSubList
} from '../TreeList/treeList'
import { FolderOpenIconArrow } from '../Icons/FolderOpenIconArrow'
import { FolderIconArrow } from '../Icons/FolderIconArrow'
import { useTheme } from 'styled-components'
import { StyledContextMenu } from '../ContextMenu/StyledContextMenu'
import { ContextMenuTrigger } from 'react-contextmenu'
import PortalContextMenu from '../ContextMenu/PortalContextMenu'

const AssetGroupItem = ({
    group,
    setGroupsActive,
    onClick = () => ({}), //get chosen Group obj, 
    partialGroups,
    isClickable = group => group.isAllowToOrder,
    groupsActive,
    renderExtraItemContent = (group) => null,
    parentsWithSelectedChildren = [], //folderIcon with arrow
    selectedGroupId,
    setSelectedGroupId,
    getContextMenuOptions = () => []
}) => {
    const theme = useTheme()
    const handleClickGroup = (group) => {
        if (!group) {
            console.warn("Undefined group clicked")
            return
        }
        onClick(group)
        setSelectedGroupId(group.id)
    }

    const handleClickFolder = (groupId) => (e) => {
        e.stopPropagation()
        setGroupsActive((prevState) => ({
            ...prevState,
            [groupId]: !prevState[groupId],
        }))
    }

    // Get child groups for rendering in a nested list
    const getChildGroup = (group) => {
        return partialGroups.filter(child => child.parent && child.parent.id === group.id)
    }

    return (
        <>
            <StyledContextMenu>

                <ContextMenuTrigger id={`${group.id}_context`} holdToDisplay={-1}>
                    <StyledItemWrapper
                        isSelectable={!group.hasChildren} // Pass isSelectable to determine style and clickability
                        isInvalid={!isClickable(group)}
                        onClick={(e) => handleClickGroup(group)} style={group.id === selectedGroupId ? { boxShadow: `inset 0px 0px 0px 2px  ${theme.primaryColor}` } : {}}
                    >
                        {group.hasChildren && (
                            <div className="d-flex" onClick={(e) => handleClickFolder(group.id)(e)}>
                                <StyledArrowWrapper>
                                    <ArrowIconNew
                                        color={groupsActive[group.id] ? '#9c9c9c' : '#3a3a38'}
                                        variant={groupsActive[group.id] ? 'down' : 'right'}
                                    />
                                </StyledArrowWrapper>
                                <StyledIconWrapper>
                                    {groupsActive[group.id] ? (
                                        parentsWithSelectedChildren.includes(group.id) ? (
                                            <FolderOpenIconArrow color={colors.gray7} />
                                        ) : (
                                            <FolderOpenIcon color={colors.gray7} />
                                        )
                                    ) : parentsWithSelectedChildren.includes(group.id) ? (
                                        <FolderIconArrow color={colors.gray7} />
                                    ) : (
                                        <FolderIcon color={colors.gray7} />
                                    )}
                                </StyledIconWrapper>
                            </div>
                        )}
                        {!group.hasChildren && (
                            <div className="d-flex">
                                <StyledDot>•</StyledDot>
                                <StyledIconWrapper>
                                    <FileIcon uniqueId={`costcenter-icon-${group.id}`} color={colors.gray5} />
                                </StyledIconWrapper>
                            </div>
                        )}
                        <StyledListItemText>{group.displayName}</StyledListItemText>
                        {renderExtraItemContent(group)}
                    </StyledItemWrapper>

                    {group.hasChildren && groupsActive[group.id] && (
                        // If the group has children and it's open, show child groups
                        <StyledTreeSubList>
                            {getChildGroup(group).map((childGroup) => (

                                <AssetGroupItem
                                    key={childGroup.id}
                                    group={childGroup}
                                    setGroupsActive={setGroupsActive}
                                    onClick={onClick}
                                    partialGroups={partialGroups}
                                    isClickable={isClickable}
                                    groupsActive={groupsActive}
                                    renderExtraItemContent={renderExtraItemContent}
                                    parentsWithSelectedChildren={parentsWithSelectedChildren}
                                    selectedGroupId={selectedGroupId}
                                    setSelectedGroupId={setSelectedGroupId}
                                    getContextMenuOptions={getContextMenuOptions}
                                    isSelectable={!childGroup.hasChildren}
                                />
                            ))}
                        </StyledTreeSubList>
                    )}
                </ContextMenuTrigger>
                {getContextMenuOptions(group).length ? (
                    <PortalContextMenu
                        contextId={`${group.id}_context`}
                        options={getContextMenuOptions(group)}
                    />
                ) : null}
            </StyledContextMenu>
        </>
    )
}

export default AssetGroupItem